import React, { useState } from 'react';
import Button from '../../event-archive/button/Button';
import './Toggle.css';

function Toggle({ post, hideType = false }) {
	const [isOn, setIsOn] = useState(false);

	const handleToggle = () => {
		setIsOn(!isOn);
	};

	return (
		<div className='toggle-container'>
			<button
				className={isOn ? 'toggle-button toggle-body-open' : 'toggle-button'}
				onClick={handleToggle}
			>
				<div className='button-column'>
					<div className='button-event-date'>
						{post.recurringEvent !== null && post.recurringEvent.length > 0 ? (
							`${post.recurringPeriod} — ${post.startTime}`
						) : (
							<>
								{post.startMonth} {post.startDay}
								{post.endDay && `-${post.endDay}`}
								{post.startTime && ` — ${post.startTime}`}
							</>
						)}
					</div>
					<div className='button-event-title'>{post.title}</div>
				</div>
				<div className='button-column second-column'>
					<div className='button-event-type'>{!hideType && post.types}</div>
					{isOn ? (
						<div className='toggle-arrow  rotated-arrow-up'>&#10132;</div>
					) : (
						<div className='toggle-arrow  rotated-arrow-down'>&#10132;</div>
					)}
				</div>
			</button>

			<div
				className={
					isOn ? 'toggle-body toggle-body-on' : 'toggle-body toggle-body-off'
				}
			>
				<div className='event-image-wrapper'>
					<img
						className='event-image'
						src={post.eventImage}
						alt={post.imageAlt}
					/>
				</div>
				<div className='toggle-body-description-row'>
					<div>
						<div className='toggle-body-description'>{post.description}</div>
						{post.details && (
							<div className='toggle-body-details'>
								<p className='toggle-body-details-title'>DETAILS</p>
								{post.details}
							</div>
						)}
					</div>
					<Button link={post.buttonUrl}>INQUIRE</Button>
				</div>
			</div>
		</div>
	);
}

export default Toggle;
